import { useState, useEffect } from 'react';
import { authManager } from '../authManager';
import { getCurrentUserOrganizationId } from '../stores/referenceDataCache';

/**
 * Restituisce in modo affidabile l'id utente e l'organization_id correnti.
 *
 * NB: NON usare `useUserStore(s => s.userProfile?.organization_id)` — lo userStore
 * NON espone uno stato `userProfile`, quindi quel selettore ritorna sempre undefined.
 * La fonte corretta è authManager / getCurrentUserOrganizationId (vedi
 * reference_userstore_orgid_undefined).
 */
export function useCurrentUser(): { orgId?: string; userId?: string } {
  const [orgId, setOrgId] = useState<string | undefined>(undefined);
  const [userId, setUserId] = useState<string | undefined>(undefined);

  useEffect(() => {
    let active = true;
    (async () => {
      const [org, user] = await Promise.all([
        getCurrentUserOrganizationId().catch(() => undefined),
        authManager.getUser().catch(() => null),
      ]);
      if (!active) return;
      if (org) setOrgId(org);
      if (user?.id) setUserId(user.id);
    })();
    return () => { active = false; };
  }, []);

  return { orgId, userId };
}
